import { render } from "./ProcedureHistory.vue?vue&type=template&id=51e69556"
import script from "./ProcedureHistory.vue?vue&type=script&lang=js"
export * from "./ProcedureHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__